import { isEmpty, union, uniq } from "ramda";

function defaultValueApplicator(template, dsCollection) {
    let pendingDefaultValues = [];

    // dataSourceNode, string -> Promise
    function applyDefaultValue(targetNode, expression) {
        const newValue = targetNode.evaluateString(expression);

        return targetNode.setValueAsync(newValue, { setDefault: true });
    }

    // DefaultValueDefinition -> Promise[AssignmentResult] 
    // TODO - reconcile AssignmentResult.
    // n.b. AssignmentResult code was removed on 2021-03-31. This signature may be incorrect
    async function evaluateAndApplyDefaultValueAsync(defaultValueDefinition) {
        const targetNodePath = defaultValueDefinition.getTarget();
        const expr = defaultValueDefinition.getExpression();
        const targetNodes = dsCollection.selectNodes(targetNodePath);

        for (const item of targetNodes) {
            const result = await applyDefaultValue(item, expr);

            if (result && result.shouldStop) {
                return result;
            }
        }

        return null;
    }

    async function runDefaultValuesInner() {
        while (!isEmpty(pendingDefaultValues)) {
            const next = pendingDefaultValues.shift();

            const result = await evaluateAndApplyDefaultValueAsync(next);

            if (result && result.shouldStop) {
                return result;
            }
        }

        return null;
    }

    // defaultValue[] -> Promise[AssignmentResult]
    async function runDefaultValuesAsync(defaultValues) {
        pendingDefaultValues = union(pendingDefaultValues, defaultValues);

        await runDefaultValuesInner();
    }

    // dataSourceNode -> Promise[AssignmentResult]
    function processAffectedDefaultValuesAsync(node) {
        const defValues = template.getDependentDefaultValues(node.getNode());

        return runDefaultValuesAsync(defValues);
    };

    // -> Promise[AssignmentResult]
    async function processAllDefaultValues() {
        const defValues = template.getAllDefaultValues();

        return await runDefaultValuesAsync(defValues);
    }

    return {
        processAffectedDefaultValuesAsync,
        processAllDefaultValues,
    };
}

export default defaultValueApplicator;